export type ImageSize = 'sm' | 'md' | 'lg'

export const sizeClassMap: Record<ImageSize, string> = {
  sm: 'size-12',
  md: 'size-16',
  lg: 'size-20',
}

export const textSizeClassMap: Record<ImageSize, string> = {
  sm: 'text-sm',
  md: 'text-base',
  lg: 'text-xl',
}

export const iconSizeClassMap: Record<ImageSize, string> = {
  sm: 'size-4',
  md: 'size-5',
  lg: 'size-6',
}

export const removeButtonSizeClassMap: Record<ImageSize, string> = {
  sm: 'size-4',
  md: 'size-5',
  lg: 'size-6',
}

export const removeIconSizeClassMap: Record<ImageSize, string> = {
  sm: 'size-2',
  md: 'size-2.5',
  lg: 'size-3',
}

export const getImageInitials = (text: string): string => {
  const wordList = text.trim().split(' ')
  if (wordList.length >= 2) {
    return `${wordList[0][0]}${wordList[1][0]}`.toUpperCase()
  }
  if (text.length >= 2) {
    return text.slice(0, 2).toUpperCase()
  }
  return text.toUpperCase() || 'NA'
}

export interface ImageSizeClasses {
  sizeClass: string
  textSizeClass: string
  iconSizeClass: string
  removeButtonClass: string
  removeIconClass: string
}

export const getSizeClasses = (size: ImageSize): ImageSizeClasses => ({
  sizeClass: sizeClassMap[size],
  textSizeClass: textSizeClassMap[size],
  iconSizeClass: iconSizeClassMap[size],
  removeButtonClass: removeButtonSizeClassMap[size],
  removeIconClass: removeIconSizeClassMap[size],
})
